import { render, staticRenderFns } from "./AcceleratorFooter.vue?vue&type=template&id=7b3c270d&scoped=true&"
import script from "./AcceleratorFooter.vue?vue&type=script&lang=js&"
export * from "./AcceleratorFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c270d",
  null
  
)

export default component.exports